import { defineMessages } from 'react-intl-next';

export default defineMessages({
	heading: {
		id: 'team-selector.add-team-modal.heading',
		defaultMessage: 'Add contributing team',
		description: 'Heading on add contributing team modal',
	},
	discoveryMessageTitle: {
		id: 'team-selector.add-team-modal.discovery-message-title',
		defaultMessage: 'The owning team is responsible for a project',
		description: 'Title on discovery message on add contributing team modal',
	},
	discoveryMessage: {
		id: 'team-selector.add-team-modal.discovery-message',
		defaultMessage:
			'Help others understand who is working here and create quick links to all your team’s work across their apps.',
		description: 'Discovery message on add contributing team modal',
	},
	discoveryMessageAction: {
		id: 'team-selector.add-team-modal.discovery-message-action',
		defaultMessage: 'Got it',
		description: 'Actions on discovery message on add contributing team modal',
	},
	discoveryMessageLearnMore: {
		id: 'team-selector.add-team-modal.discovery-message-learn-more',
		defaultMessage: 'Learn more',
		description: 'Learn more on discovery message on add contributing team modal',
	},
	cancelButton: {
		id: 'team-selector.add-team-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Text for cancel button on add contributing team modal',
	},
	addButton: {
		id: 'team-selector.add-team-modal.add-button',
		defaultMessage: 'Add',
		description: 'Text for add button on add contributing team modal',
	},
});
